import Channel from '../../../classes/channel';
import FlavourConfig from '../../../config/flavours';
import InformationIcon from '@components/atoms/icons/information';
import L7DIcon from '@components/atoms/icons/l7d';
import MultiScreenIcon from '@components/atoms/icons/multiscreen';
import RecordIcon from '@components/atoms/icons/record';
import RestartIcon from '@components/atoms/icons/restart';
import Service from '../../../types/enums/services';
import { mediaSelector } from '../../../store/slices/media.slice';
import { useAppSelector } from '../../../store/hooks';
import { useMemo } from 'react';

function usePlayerServices(channel: Channel) {
  const { ready, timeshift } = useAppSelector(mediaSelector);

  const services = useMemo(() => {
    const { services } = channel || {};

    const info = {
      Icon: InformationIcon,
      active: services?.includes(Service.LIVE),
      width: 20,
      height: 20,
    };
    const recordings = {
      Icon: RecordIcon,
      active:
        services?.includes(Service.RECORDINGS) ||
        services?.includes(Service.RECORDINGS_FREE),
      width: 30,
      height: 30,
    };
    const restart = {
      Icon: RestartIcon,
      active:
        (services?.includes(Service.RESTART) ||
          services?.includes(Service.RESTART_FREE) ||
          services?.includes(Service.TIMESHIFT)) &&
        (ready ? timeshift : true),
      width: 18,
      height: 18,
    };
    const multiscreen = {
      active: services?.includes(Service.MULTISCREEN),
      Icon: MultiScreenIcon,
      width: 23,
      height: 16,
    };
    const u7d = {
      active:
        services?.includes(Service.YOU_MISSED_IT) ||
        services?.includes(Service.YOU_MISSED_IT_FREE),
      Icon: L7DIcon,
      width: 22,
      height: 14,
    };

    return services
      ? FlavourConfig.capabilities.u7d
        ? [info, recordings, restart, multiscreen, u7d]
        : [info, recordings, restart, multiscreen]
      : [];
  }, [channel, timeshift]);

  return services;
}

export default usePlayerServices;
